module.exports = __webpack_public_path__ + "img/clues.038c3539.svg";